module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (40).f4a81a72.png";